export const isMessageFromMe = (message, person) => {
  return person?._id && message?.user === person._id;
};
